/* eslint-disable import/prefer-default-export */
export const onKeydownAllowNumbersOnly = (event) => {
  const keyCode = (event.which) ? event.which : event.keyCode;
  const isMetaKey = event.metaKey;
  const isBackspace = keyCode === 8;
  const isArrow = (keyCode >= 37) && (keyCode <= 40);
  const isNumber = (keyCode >= 48 && keyCode <= 57) || (keyCode >= 96 && keyCode <= 105);

  if (!isMetaKey && !isBackspace && !isArrow && !isNumber) {
    event.preventDefault();
  }
};
